import { render, staticRenderFns } from "./TVD.vue?vue&type=template&id=8930022e&scoped=true&"
import script from "./TVD.vue?vue&type=script&lang=js&"
export * from "./TVD.vue?vue&type=script&lang=js&"
import style0 from "./TVD.vue?vue&type=style&index=0&id=8930022e&scoped=true&lang=css&"
import style1 from "./TVD.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8930022e",
  null
  
)

export default component.exports